export const getCsrf = () => {
  return (
    document
      .querySelector(`meta[name="csrf-token"]`)
      ?.getAttribute("content") ?? ""
  );
};
